import VendorEnrollmentView from './containers/VendorEnrollmentView';
export default VendorEnrollmentView;

export {uiDataVendorEnrollmentView} from './reducers/VendorEnrollmentView';
